import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3 }}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-50 w-12 h-12 border border-[#F47B20]/50 bg-[#09090b]/80 backdrop-blur-sm flex items-center justify-center hover:bg-[#F47B20] hover:border-[#F47B20] transition-all duration-300 group"
          aria-label="Back to top"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-[#F47B20] group-hover:text-black transition-colors">
            <path d="M8 12V4M4 7l4-4 4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {/* Crosshair corners */}
          <span className="absolute -top-px -left-px w-2 h-2 border-t border-l border-[#F47B20]/30 group-hover:border-black/30 transition-colors" />
          <span className="absolute -top-px -right-px w-2 h-2 border-t border-r border-[#F47B20]/30 group-hover:border-black/30 transition-colors" />
          <span className="absolute -bottom-px -left-px w-2 h-2 border-b border-l border-[#F47B20]/30 group-hover:border-black/30 transition-colors" />
          <span className="absolute -bottom-px -right-px w-2 h-2 border-b border-r border-[#F47B20]/30 group-hover:border-black/30 transition-colors" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
